import { X } from "lucide-react";
import React, { Dispatch } from "react";

import { IgAccordion } from "@intelligems/ig-theme";
import {
  OrgShopIdDto,
  StripeApiGetAllProductFeaturesByProductIdResponseBodyType,
  StripeApiPriceDto,
  StripeApiProductDto,
} from "@intelligems/ig-types";
import { Grid, IconButton, useTheme } from "@mui/material";
import { useStripeApi } from "@src/api/stripe/stripe-api";
import { SkeletonGroup } from "@src/components/Utils/SkeletonGroup";
import { CreateSubscriptionReducerAction } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/subscriptionReducer";
import { ProductFeaturesTable } from "@src/features/admin/pages/overview/components/Tables/ProductFeatureTable/ProductFeaturesTable";

interface ProductAccordionProps {
  price: StripeApiPriceDto | undefined;
  product: StripeApiProductDto;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
  orgs: OrgShopIdDto[];
}

export const ProductAccordion = ({
  price,
  product,
  orgs,
  dispatchPayload,
}: ProductAccordionProps) => {
  const theme = useTheme();
  const productFeatures =
    useStripeApi<StripeApiGetAllProductFeaturesByProductIdResponseBodyType>({
      action: "getAllProductFeaturesByProductId",
      productId: product.id,
      orgs,
    });

  return (
    <IgAccordion
      title={product.name}
      summaryActionButtons={[
        <IconButton
          key={"close-btn"}
          onClick={() => {
            dispatchPayload({
              type: "removeItemByProductId",
              value: product.id,
            });
          }}
        >
          <X size={16} />
        </IconButton>,
      ]}
    >
      <Grid item mt={1}>
        <Grid item>
          {productFeatures.isSuccess ? (
            <ProductFeaturesTable features={productFeatures.data.features} />
          ) : (
            <SkeletonGroup lines={4} />
          )}
        </Grid>
      </Grid>
    </IgAccordion>
  );
};
